import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { forEach } from "@angular/router/src/utils/collection";
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, elementAt, window } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
//declare var google: any;
@Component({
    selector: "finalpage",
    template: require('./finalpage.component.html'),
    styles: [require('./finalpage.component.css')]
})
export class FinalPageComponent implements OnChanges {

    report: CollisionReport;
    customerList: Array<String> = [];
    modelList: Array<String> = []
    colorList: Array<String> = [];
    location: GeoLocation;
    driverImages: Array<DriverPictures> = [];
    @ViewChild('gmap') gmapElement: any;
    //marker: any = new google.maps.Marker();
    marker1: any;
    latlong: any;
    stringformat: any;
    infowindow: any;
    street1: any;
    prep1: any; prep2: any; address: any;
    //geocoder: any = new google.maps.Geocoder();
    addressSplitter: any;
    map: any;
    date: Date = new Date();
    year1: any;
    year2: any;
    year3: any;
    accidentdate: Date = new Date();
    CollisionYear: any;
    CollisionMonth: any;
    CollisionDay: any;

    //
    FirstName: any;
    LastName: any;
    EmailAddress: any;
    PrimaryPhoneNumber: any;
    CollisionDate: any;

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private domSanitizer: DomSanitizer) {
        this.report = appcomponent.getReport();

        if (typeof this.report.CollisionReportId == 'undefined') {
            this.router.navigate(["home"]);
        }
        if (this.report.CollisionLocation == null) {
            this.location = <GeoLocation>{};
        }
        else {
            this.location = this.report.CollisionLocation;
        }

        //var year = this.date.getFullYear();


        //this.year1 = year.toString();
        //this.year2 = (year + 1).toString();
        //this.year3 = (year + 2).toString();


        //var month = this.date.getMonth() + 1;
        //var day = this.date.getUTCDate();

        //Review Information


        this.FirstName = this.report.Firstname;
        this.LastName = this.report.Lastname;
        this.EmailAddress = this.report.EmailAddress;
        this.PrimaryPhoneNumber = this.report.PrimaryPhoneNumber;
        this.CollisionDate = this.report.CollisionDate;

        document.body.scrollTop = 0;

        appcomponent.isLastPage = true; // Hide the Clear button
    }

    onPhoneInput(): void {
        var phone = this.report.PrimaryPhoneNumber.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.PrimaryPhoneNumber = v;
    }

    onPlateInput(): void {
        var v = this.report.VehiclePlate.replace(/\s/, '').replace('_', '').replace(/\W/g, '');
        this.report.VehiclePlate = v
    }


    datePicker(): void {
        var year = this.CollisionYear

        if (year == 1) {
            year = this.date.getFullYear()
        }
        else if (year == 2) {
            year = this.date.getFullYear() + 1
        }
        else if (year == 3) {
            year = this.date.getFullYear() + 2
        }

        var month = this.CollisionMonth
        var day = this.CollisionDay

        //alert("year: " + year + " month: " + month + " day: " + day);

        var datestring = year.toString() + '-' + month.toString() + '-' + day.toString();
        var timestring = '00:00:00';
        var insexpDate = new Date(datestring + ' ' + timestring);
        //if (accdate) {
        //    alert('wrong: '+accdate);
        //}
        this.report.InsuranceExpiryDate = insexpDate;
        //alert(accdate);
    }




    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefines");
    }
    //MAP CODE START
    //ngAfterViewInit() {
    //    var mapProp = {
    //        center: new google.maps.LatLng(43.756342, -79.553549),
    //        zoom: 8,
    //        streetViewControl: false,
    //        mapTypeId: google.maps.MapTypeId.ROADMAP
    //    };
    //    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    //    try {
    //        this.setAutocomplete(this.map);
    //    }
    //    catch{
    //    }


    //}
    //geocodePosition(pos: any): void {
    //    var self = this;
    //    this.geocoder.geocode({
    //        latLng: pos
    //    }, function (responses: any) {
    //        if (responses && responses.length > 0) {

    //            self.latlong = pos;
    //            self.parseStreetTypes(responses);
    //            self.updateMarkerAddress(responses[0].formatted_address);
    //            //markerFormatter(marker, map);


    //        } else {
    //            self.updateMarkerAddress('Cannot determine address at this location.');
    //        }
    //    });
    //}
    //setAutocomplete(map: any): void {
    //    var autoCompleteOptions = {
    //        types: [],
    //        componentRestrictions: { country: 'ca' }
    //    };
    //    var autoCompleteElement = document.getElementById('SpecificAddress');
    //    var self = this;
    //    //map.controls[google.maps.ControlPosition.TOP_LEFT].push(autoCompleteElement);
    //    //map.controls[google.maps.ControlPosition.TOP_LEFT].push(autoCompleteElement);
    //    var searchBox = new google.maps.places.Autocomplete(autoCompleteElement, autoCompleteOptions);
    //    searchBox.bindTo('bounds', map);
    //    google.maps.event.addListener(searchBox, 'place_changed', function () {
    //        var place = searchBox.getPlace();
    //        if (!place.geometry) {
    //            // Inform the user that the place was not found and return.
    //            //updateMarkerAddress('Google is unable to find the address.');
    //            self.addressGeocode(self.location, self.map);
    //            return;
    //        }
    //        else {
    //            // If the place has a geometry, then present it on a map.
    //            if (place.geometry.viewport) {
    //                map.fitBounds(place.geometry.viewport);
    //            } else {
    //                map.setCenter(place.geometry.location);
    //                map.setZoom(17);

    //            }
    //            var address = '';
    //            if (place.address_components) {
    //                address = [
    //                    (place.address_components[0] && place.address_components[0].short_name || ''),
    //                    (place.address_components[1] && place.address_components[1].short_name || ''),
    //                    (place.address_components[2] && place.address_components[2].short_name || '')
    //                ].join(' ');
    //            }

    //            self.updateMarkerPosition(place.geometry.location);
    //            self.geocodePosition(place.geometry.location);
    //        }

    //    });
    //    this.updateMarkerPosition(this.latlong);
    //    this.geocodePosition(this.latlong);
    //    this.addListnerMarker();
    //}
    //updateMarkerStatus(str: string): void {
    //    //document.getElementById('markerStatus').innerHTML = str;

    //}

    //updateMarkerPosition(latLng: any): void {
    //    this.location.Latitude = latLng.lat();
    //    this.location.Longitude = latLng.lng();
    //    //  DEFAULTLAT = document.getElementById('LATTITUDETEXT').value;
    //    // DEFAULTLONG = document.getElementById('LONGITUDETEXT').value;
    //}

    //updateMarkerAddress(str: string) {
    //    // document.getElementById('address').innerHTML = str;

    //}


    //formatInnerAddress(addressToFormat: string): string {
    //    return addressToFormat.replace(" AVENUE ", " AVE ").replace(" STREET ", " ST ").replace(" DRIVE ", " DR ").replace(" DRIVE ", " DR ").replace(" BOULEVARD ", " BLVD ").replace(" ROAD ", " RD ").replace(" EXPRESSWAY ", " EXPY ");
    //}
    //formatAddressForCroms(addressToFormat: string): string {

    //    return this.formatInnerAddress(addressToFormat.replace(" AVENUE  ", " AVE").replace(" STREET  ", " ST").replace(" EAST  ", " E").replace(" WEST  ", " W").replace(" NORTH  ", " N").replace(" SOUTH  ", " S").replace(" DRIVE  ", " DR").replace(" DRIVE  ", " DR").replace("MACDONALD-CARTIER FREEWAY 401", "HWY 401").replace("EXPRESS TOLL ROUTE", "HWY 407").replace(" BOULEVARD  ", " BLVD").replace(" ROAD  ", " RD").replace("MACDONALD-CARTIER EXPRESSWAY 401", "HWY 401").replace("MACDONALD-CARTIER COLLECTOR 401", "HWY 401").replace("MACDONALD-CARTIER EXPRESSWAY", "HWY 401").replace("MACDONALD-CARTIER FREEWAY", "HWY 401").replace("MACDONALD-CARTIER COLLECTOR", "HWY 401").replace("ONTARIO 406", "HWY 406"));
    //}

    //highwayReplace(highwayAddress: string): string {
    //    return highwayAddress.toUpperCase().replace('ONTARIO 401', 'HWY 401').replace('ONTARIO 404', 'HWY 404').replace('ONTARIO 409', 'HWY 409').replace('ONTARIO 410', 'HWY 410').replace('ONTARIO 427', 'HWY 427').replace('ONTARIO 401', 'HWY 401').replace('ONTARIO 400', 'HWY 400').replace("ONTARIO 406", "HWY 406");
    //}
    //addListnerMarker(): void {

    //    // Add dragging event listeners.
    //    google.maps.event.addListener(this.marker, 'dragstart', function () {
    //        //this.updateMarkerAddress('Dragging...');
    //    });

    //    google.maps.event.addListener(this.marker, 'drag', function (marker: any) {
    //        //  this.updateMarkerStatus('Dragging...');
    //        //   this.updateMarkerPosition(marker.getPosition());
    //    });

    //    google.maps.event.addListener(this.marker, 'dragend', function () {
    //        //   updateMarkerStatus('Drag ended');
    //        //  geocodePosition(marker.getPosition());
    //        // markerFormatter(marker, map);

    //    });

    //}
    //markerFormatter(marker: any, map: any): void {

    //    this.stringformat = '<div  class="InfoDiv" >' + this.stringformat + '</div>';
    //    this.infowindow = new google.maps.InfoWindow({
    //        content: this.stringformat
    //    });

    //    this.infowindow.open(map, marker);
    //}

    //geocode(): void {
    //    this.addressGeocode(this.location, this.map);
    //}

    //addressGeocode(geolocaton: GeoLocation, map: any): void {

    //    //   var latlong: any;
    //    var stringformat: any;
    //    var street1: any;
    //    var prep1: any;
    //    var prep2: any;
    //    var self = this;
    //    var address = this.location.SpecificAddress;
    //    this.geocoder.geocode({
    //        'address': address, region: 'Canada'
    //    }, function (results: any, status: any) {
    //        if (status == google.maps.GeocoderStatus.OK) {

    //            self.latlong = results[0].geometry.location;
    //            self.location.Latitude = results[0].geometry.location.lat();
    //            self.location.Longitude = results[0].geometry.location.lng();
    //            geolocaton.Longitude = results[0].geometry.location.lng();
    //            geolocaton.Latitude = results[0].geometry.location.lat();
    //            self.parseStreetTypes(results);
    //            map.setCenter(self.latlong);
    //        }
    //        else {
    //            alert("The Address Entered Cannot Be Found. Please Try Again.[" + status + "]");
    //        }
    //    });
    //}

    //assignR1R2(prep1: any, prep2: any): boolean {

    //    alert('assign');
    //    this.location.R1Address = prep1;
    //    this.location.R2Address = prep2;
    //    return false;
    //}

    //swapAddress(): void {

    //    var addr = this.location.R1Address;
    //    this.location.R1Address = this.location.R2Address;
    //    this.location.R2Address = addr;
    //}

    //CheckAddressTrail(): void {

    //    var prov = this.location.Province;
    //    this.location.SpecificAddress = this.location.SpecificAddress.replace(",", "").replace("ONTARIO", "").replace("CANADA", "").replace("UNITED STATES", "");
    //    this.location.SpecificAddress = this.location.SpecificAddress + prov;

    //}

    //parseStreetTypes(results: any): void {

    //    var IsAdministrativeLevel3Found = "";
    //    var resulttype = results[0].types;
    //    if (resulttype.length > 1)
    //        resulttype = resulttype[0];

    //    switch (resulttype.toString()) {

    //        case "intersection":

    //            for (var addComponent in results[0].address_components) {
    //                var component = results[0].address_components[addComponent];
    //                for (var typeIndex in component.types) {


    //                    if (component.types[typeIndex] == 'route') {

    //                        this.street1 = component.long_name.toUpperCase() + "  ";
    //                        this.street1 = this.formatAddressForCroms(this.street1);
    //                        this.street1 = this.highwayReplace(this.street1);
    //                    }
    //                }
    //            }



    //            if (results[0].formatted_address.indexOf('&') != -1) {

    //                this.prep1 = results[0].formatted_address.substring(0, results[0].formatted_address.indexOf('&')) + "  ";
    //                this.prep1 = this.formatAddressForCroms(this.prep1.toUpperCase());
    //                this.prep2 = results[0].formatted_address.substring(results[0].formatted_address.indexOf('&') + 2, results[0].formatted_address.indexOf(',')) + "  ";
    //                this.prep2 = this.formatAddressForCroms(this.prep2.toUpperCase());
    //                this.prep1 = this.highwayReplace(this.prep1);
    //                this.prep2 = this.highwayReplace(this.prep2);
    //                if (this.prep1 == this.prep2) {
    //                    this.prep2 = "";
    //                }

    //                this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                    //'<FONT  style="color: #666666; font-size: small; font-weight: bold" >' + document.getElementById('LATTITUDETEXT').value + ',' + document.getElementById('LONGITUDETEXT').value + '</FONT><br/>' +
    //                    '<br/>Set  &nbsp;&nbsp;<button type="buton"  onclick="document.getElementById(\'R1Address\').value = \'' + this.prep1.toUpperCase() + '\';document.getElementById(\'R2Address\').value = \'' + this.prep2.toUpperCase() + '\';return false;" > R1 = ' + this.prep1.toUpperCase() + '   &nbsp;&nbsp;R2 =' + this.prep2.toUpperCase() + '</button>' +
    //                    '<br/>Set  &nbsp;&nbsp;<button  onclick="document.getElementById(\'R2Address\').value = \'' + this.prep2.toUpperCase() + '\';document.getElementById(\'R2Address\').value = \'' + this.prep1.toUpperCase() + '\';return false;" > R1 = ' + this.prep2.toUpperCase() + '   &nbsp;&nbsp;R2 =' + this.prep1.toUpperCase() + '</button>';
    //                this.location.R1Address = this.prep1.toUpperCase();
    //                this.location.R2Address = this.prep2.toUpperCase();

    //            }
    //            else {

    //                this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                    //'<FONT  style="color: #666666; font-size: small; font-weight: bold" >' + document.getElementById('LATTITUDETEXT').value + ',' + document.getElementById('LONGITUDETEXT').value + '</FONT><br/>' +
    //                    '<br/>Set <button type="buton" onClick="document.getElementById(\'R1Address\').value = \'' + this.prep1.toUpperCase() + '\';return false;" >R1=' + this.street1.toUpperCase() + '</button>';
    //                this.location.R1Address = this.prep1.toUpperCase();
    //            }
    //            this.marker.setMap(null);
    //            this.marker = new google.maps.Marker({
    //                map: this.map,
    //                position: this.latlong,
    //                title: 'CROMS Geocode',
    //                draggable: true
    //            });
    //            this.addListnerMarker();
    //            this.markerFormatter(this.marker, this.map);
    //            break;
    //        case "premise":
    //        case "street_address": for (var addComponent in results[0].address_components) {
    //            var component = results[0].address_components[addComponent];
    //            for (typeIndex in component.types) {

    //                if (component.types[typeIndex] == 'street_number') {


    //                    this.street1 = component.long_name.toUpperCase() + "  ";
    //                    this.street1 = this.formatAddressForCroms(this.street1.toUpperCase());
    //                }

    //                if (component.types[typeIndex] == 'route') {


    //                    this.prep1 = component.long_name + "  ";
    //                    this.prep1 = this.formatAddressForCroms(this.prep1.toUpperCase());
    //                    if (this.street1.toString() == this.prep1) {
    //                        this.street1 = this.street1.toString() + "  ";

    //                    }
    //                    else {

    //                        this.street1 = this.street1.toString() + ' ' + component.long_name.toUpperCase() + "  ";
    //                        this.street1 = this.formatAddressForCroms(this.street1);
    //                    }
    //                    this.prep1 = this.prep1.replace("  ", "");
    //                    this.street1 = this.street1.replace("  ", "");
    //                    this.prep1 = this.highwayReplace(this.prep1);
    //                    this.street1 = this.highwayReplace(this.street1);
    //                }


    //            }
    //            this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                //'<FONT  style="color: #666666; font-size: small; font-weight: bold" >' + document.getElementById('LATTITUDETEXT').value + ',' + document.getElementById('LONGITUDETEXT').value + '</FONT><br/>' +
    //                '<br/>Set <button type="buton" onClick="document.getElementById(\'R1Address\').value = \'' + this.street1 + '\';return false;" >R1=' + this.street1 + '</button>' +
    //                '<br/>Set <button type="buton" onClick="document.getElementById(\'R2Address\').value = \'' + this.prep1 + '\';return false;" >R1=' + this.prep1 + '</button>';

    //            this.location.R1Address = this.street1.toUpperCase();
    //            this.marker.setMap(null);
    //            this.marker = new google.maps.Marker({
    //                map: this.map,
    //                position: this.latlong,
    //                title: 'CROMS Geocode',
    //                draggable: true
    //            });
    //            this.addListnerMarker();
    //            this.markerFormatter(this.marker, this.map);
    //            break;
    //        }
    //        case "route":

    //            for (var addComponent in results[0].address_components) {
    //                var component = results[0].address_components[addComponent];
    //                for (typeIndex in component.types) {


    //                    if (component.types[typeIndex] == 'route') {

    //                        this.street1 = component.long_name.toUpperCase() + "  ";
    //                        this.street1 = this.formatAddressForCroms(this.street1.toUpperCase());
    //                        this.street1 = this.highwayReplace(this.street1);
    //                    }


    //                }
    //            }



    //            if (results[0].formatted_address.indexOf('&') != -1) {

    //                this.prep1 = results[0].formatted_address.substring(0, results[0].formatted_address.indexOf('&')) + "  ";
    //                this.prep1 = this.formatAddressForCroms(this.prep1.toUpperCase());
    //                this.prep2 = results[0].formatted_address.substring(results[0].formatted_address.indexOf('&') + 2, results[0].formatted_address.indexOf(',')) + "  ";
    //                this.prep2 = this.formatAddressForCroms(this.prep2.toUpperCase());
    //                this.prep1 = this.highwayReplace(this.prep1);
    //                this.prep2 = this.highwayReplace(this.prep2);
    //                if (this.prep1 == this.prep2) {
    //                    this.prep2 = "";
    //                }
    //                this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                    '<br/>Set  &nbsp;&nbsp;<button type="buton"  onclick="document.getElementById(\'R1Address\').value = \'' + this.prep1.toUpperCase() + '\';document.getElementById(\'R2Address\').value = \'' + this.prep2.toUpperCase() + '\';return false;" > R1 = ' + this.prep1.toUpperCase() + '   &nbsp;&nbsp;R2 =' + this.prep2.toUpperCase() + '</button>' +
    //                    '<br/>Set  &nbsp;&nbsp;<button  onclick="document.getElementById(\'R2Address\').value = \'' + this.prep2.toUpperCase() + '\';document.getElementById(\'R2Address\').value = \'' + this.prep1.toUpperCase() + '\';return false;" > R1 = ' + this.prep2.toUpperCase() + '   &nbsp;&nbsp;R2 =' + this.prep1.toUpperCase() + '</button>';
    //                this.location.R1Address = this.prep1.toUpperCase();
    //                this.location.R2Address = this.prep2.toUpperCase();
    //            }
    //            else {

    //                this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                    '<br/>Set <button type="buton"  onClick="document.getElementById(\'R1Address\').value = \'' + this.street1.toUpperCase() + '\';return false;" >R1=' + this.street1.toUpperCase() + '</button>';


    //                this.location.R1Address = this.street1.toUpperCase();
    //            }
    //            this.marker.setMap(null);
    //            this.marker = new google.maps.Marker({
    //                map: this.map,
    //                position: this.latlong,
    //                title: 'CROMS Geocode',
    //                draggable: true
    //            });
    //            this.addListnerMarker();
    //            this.markerFormatter(this.marker, this.map);
    //            break;
    //        default:
    //            this.addressSplitter = this.address.split('&');
    //            if (this.addressSplitter[0]) {
    //                this.location.R1Address = this.addressSplitter[0];
    //            }
    //            if (this.addressSplitter[1]) {
    //                this.location.R2Address = this.addressSplitter[1].substring(this.addressSplitter[1].indexOf('&') + 2, (this.addressSplitter[1] + ",").indexOf(','));
    //            }
    //            break;

    //    }
    //    //document.getElementById('MunicipalityHints').innerHTML = "";
    //    //Municipilaty
    //    for (var addComponent in results[0].address_components) {
    //        var component = results[0].address_components[addComponent];
    //        for (typeIndex in component.types) {


    //            if (component.types[typeIndex] == 'locality') {
    //                this.location.County = component.long_name;
    //                if (this.street1 == "" && this.prep1 == "" && this.prep2 == "") {
    //                    this.stringformat = '<div align="left" ><br/><FONT  style="color: #666666; font-size: small; font-weight: bold" >' + results[0].formatted_address.toString() + '</FONT><br/>' +
    //                        //'<FONT  style="color: #666666; font-size: small; font-weight: bold" >' + document.getElementById('LATTITUDETEXT').value + ',' + document.getElementById('LONGITUDETEXT').value + '</FONT><br/>' +
    //                        '<br/>Set &nbsp;&nbsp;<a href="" onClick="document.getElementById(\'R1Address\').value = document.getElementById(\'MUNICIPALITY\').value;return false;" >R1&nbsp;&nbsp;=&nbsp;&nbsp;' + this.location.District + '</a>';
    //                    this.location.R1Address = this.location.District.toUpperCase();

    //                }
    //            }

    //            if (component.types[typeIndex] == 'administrative_area_level_2') {
    //                this.location.District = component.long_name;
    //                this.location.District = this.location.District.toUpperCase().replace(" DIVISION", "").replace(" REGIONAL MUNICIPALITY", "").replace(" REGION", "");
    //                IsAdministrativeLevel3Found = "FOUND";
    //            }
    //            else {
    //                //ADDED on 06/05/2015 since not all address returns administrative_area_level_2
    //                // alert(IsAdministrativeLevel3Found);
    //                if (IsAdministrativeLevel3Found != "FOUND")
    //                    this.location.District = this.location.County;
    //            }
    //            if (component.types[typeIndex] == 'administrative_area_level_3') {
    //                //  municipalityHints = component.short_name;

    //                // document.getElementById('MunicipalityHints').innerHTML = 'Set &nbsp;&nbsp;<a href="" onClick="document.getElementById(\'MUNICIPALITY\').value = \'' + municipalityHints + '\';return false;" >MUNICIPALITY&nbsp;&nbsp;=&nbsp;&nbsp;' + municipalityHints + '</a>';
    //            }
    //        }
    //    }

    //}

    //MAP CODE END


    onDidReportInsuranceChange(value: boolean): void {
        this.report.ReportToInsurance = value;
    }
    onFailToRemainChange(value: boolean): void {
        this.report.FailToRemain = value;
    }


    onBack(): void {
        this.BackAndPost("email");
    }
    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
        //    this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }
    onSubmit(): void {
        //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));


        this.ValidateAndPost("Done");

        //GO TO NEXT PAGE
    }

    onDeleteInvolved(involved: InvolvedPassergerInfo): void {
        if (confirm("Do you really want to delete this entity?")) {
            for (var i = 0; i < this.report.InvolvedPassergerInfos.length; i++) {
                if (this.report.InvolvedPassergerInfos[i].InvolvedPersonIndex == involved.InvolvedPersonIndex) {

                    if (this.report.InvolvedPassergerInfos[i].InvolvedId > 0) {
                        var url = this.baseUrl + "api/report/DeleteInvolved/" + this.report.InvolvedPassergerInfos[i].InvolvedId;
                        this.http
                            .delete(url)
                            .subscribe(res => {
                                this.report.InvolvedPassergerInfos.splice(i, 1);
                            }, error => console.log(error));
                    }
                    else
                        this.report.InvolvedPassergerInfos.splice(i, 1);
                    break;
                }
            }
        }

    }

    //ValidateInsuranceExpiry(): boolean {
    //    //const date: Date = new Date();

    //    this.datePicker();

    //    if (this.report.InsuranceExpiryDate <= this.report.CollisionDate) {
    //        //alert(this.report.InsuranceExpiryDate.toString());
    //        //alert(this.report.CollisionDate.toString());
    //        alert("Please enter valid Insurance Expiry Date");
    //        return false;
    //    }
    //    else {
    //        //alert(this.report.InsuranceExpiryDate.toString());
    //        //alert(this.report.CollisionDate.toString());
    //        //alert("Insurance Expiry okay")
    //        return true;
    //    }
    //}

    IsValid(): boolean {
        //var insExp = this.ValidateInsuranceExpiry();
        //alert(insExp);
        return true;
    }

    private ValidateAndPost(page: string) {
        var isValid = this.IsValid();
        if (isValid) {
            this.report.IsCouncellorReviewPageValid = true;
            this.report.CollisionLocation = this.location;
            this.report.IsMapPageValid = true;
            this.report.IsFinalized = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            // this.router.navigate([page]);
        }
    }

    searchInsurance = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getInsuranceData(term))
        );

    getInsuranceData(term: string): Array<String> {

        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Customer/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.customerList.push(data[i]);
                }
            }, error => console.log(error));
        if (data == null) {
            this.customerList.push("Not Found");
        }
        return Array.from(new Set(this.customerList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }
    searchCar = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getCarData(term))
        );

    getCarData(term: string): Array<String> {

        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Car/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.modelList.push(data[i]);
                }
            }, error => console.log(error));
        if (data == null) {
            this.modelList.push("Not Found");
        }
        return Array.from(new Set(this.modelList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }

    searchColor = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.getColorData(term))
        );

    getColorData(term: string): Array<String> {

        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/Color/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.colorList.push(data[i]);
                }
            }, error => console.log(error));
        if (data == null) {
            this.colorList.push("Not Found");
        }
        return Array.from(new Set(this.colorList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }
    onLoadVIN(): void {
        if (this.report.VIN != null && this.report.VIN.trim().length > 0) {
            var url = this.baseUrl + "api/report/VIN/" + this.report.VIN;
            var data: any;
            this.http
                .get(url)
                .subscribe(res => {
                    data = res as VINInformation;
                    if (data) {
                        //   this.report.VIN = data.VIN;
                        // this.report.VehicleColourId = data.VehicleColorId;
                        this.report.VehicleYear = data.ModelYear;
                        this.report.CarModelId = data.VehicleModelId;
                        this.report.CarMakeModel = data.CarModelName;
                    }
                }, error => console.log(error));
        }
    }

    loadimage() {
        var url = this.baseUrl + "api/driverimage/CheckImages/" + this.report.Location.LocationId + "/" + this.report.VehiclePlate;
        /*OLD CODE FOR LOAD IMAGE
        //var url = this.baseUrl + "api/driverimage/GetImages/" + this.report.Location.LocationId + "/" + this.report.VehiclePlate;
        //var data: any;
        //this.driverImages = <DriverPictures[]>{};
        //this.http
        //    .get(url)
        //    .subscribe(res => { 
        //        data = res as DriverPictures[];
        //        for (let i = 0; i < data.length; i++) {
        //            this.driverImages.push(data[i]);
        //        }
        //    }, error => console.log(error));
        //if (data == null) {
        //   // this.colorList.push("Not Found");
        //}*/

        var data: any;
        var foundPictures: boolean;
        //this.http
        //    .get(url)
        //    .subscribe(res => {
        //        this.pictureResults = res as boolean;
        //    }
        //)
        this.http
            .get(url)
            .subscribe(res => {
                data = res as boolean;
                if (data) {
                    //   this.report.VIN = data.VIN;
                    // this.report.VehicleColourId = data.VehicleColorId;
                    //foundPictures = data;
                    //alert(foundPictures);
                    //console.log(foundPictures);
                    alert("Images Found!");
                }
                else {
                    alert("No Images Found");
                }
            }, error => console.log(error));
    }
}